var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var createReminderMessageService = function () {
    return import("~/services/common-service/reminder-message.service");
};
import { ReminderMessageType } from "~/utils/reminder.service";
export default {
    namespaced: true,
    state: {
        unReadCount: 0,
        legalUnReadCount: 0,
        taskList: [],
        messageBoxVisible: false,
        messageLegalBoxVisible: false,
        breadCrumbPathList: [],
        isMessageShow: false
    },
    mutations: {
        updateMessageBoxVisible: function (state, visible) {
            state.messageBoxVisible = visible;
        },
        updateLegalMessageBoxVisible: function (state, visible) {
            state.messageLegalBoxVisible = visible;
        },
        updateTaskList: function (state, list) {
            state.taskList = list;
        },
        updatedIsMessageShow: function (state, visible) {
            state.isMessageShow = visible;
        },
        /**
         * 更新未读消息数
         * @param state
         * @param count
         */
        updateUnReadCount: function (state, count) {
            state.unReadCount = count;
        },
        updateLegalUnReadCount: function (state, count) {
            state.legalUnReadCount = count;
        },
        getBreadcrumbPathList: function (state, matchedRouter) {
            console.log("bread", matchedRouter);
        }
    },
    actions: {
        /**
         * 查询未读消息树
         */
        updateUnReadCount: function (_a) {
            var commit = _a.commit, rootState = _a.rootState;
            return __awaiter(this, void 0, void 0, function () {
                var ReminderMessageService;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, createReminderMessageService()];
                        case 1:
                            ReminderMessageService = (_b.sent()).ReminderMessageService;
                            if (rootState.userToken) {
                                ReminderMessageService.getInstance()
                                    .getUnReadCount()
                                    .subscribe(function (count) {
                                    commit("updateUnReadCount", count);
                                });
                                commit("updateUnReadCount", 0);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        updateLegalUnReadCount: function (_a) {
            var commit = _a.commit, rootState = _a.rootState;
            return __awaiter(this, void 0, void 0, function () {
                var ReminderMessageService;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, createReminderMessageService()];
                        case 1:
                            ReminderMessageService = (_b.sent()).ReminderMessageService;
                            if (rootState.userToken) {
                                ReminderMessageService.getInstance()
                                    .getUnReadCount(ReminderMessageType.LegalTaskMessage)
                                    .subscribe(function (count) {
                                    commit("updateLegalUnReadCount", count);
                                });
                                commit("updateLegalUnReadCount", 0);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    }
};
